/** Mirakl's page ids. Each event and ad request says which kind of page it came from. */
export const MIRAKL_PAGE = {
  HOME: 1000,
  PDP: 1200,
  PLP: 1400,
  BASKET: 1600,
  SEARCH: 2000,
  ORDER: 2400,
} as const;

export type MiraklPageId = (typeof MIRAKL_PAGE)[keyof typeof MIRAKL_PAGE];

/**
 * Beacon route paths, relative to a web app's public API base path such as `/productdetails-api/`.
 *
 * Never post to `/api/` directly: outside local development public-router sends `/api/` to the
 * Mononoth APIs. Each app is reached through its own prefix and rewrites it back to its `/api/`
 * (`publicApiRewrites`), so these are served from `pages/api/mirakl/view.ts` and
 * `pages/api/mirakl/click.ts` in every app that sends beacons.
 */
export const MIRAKL_BEACON_PATHS = {
  view: 'mirakl/view',
  click: 'mirakl/click',
} as const;
